// 2026 harvest packaging: every lot ships vacuum-packed in 30kg boxes,
// each holding two 15kg bricks.
export const BOX_KG = 30;

export function kgToBoxes(kg: number): number {
  if (!kg || kg <= 0) return 0;
  return Math.round(kg / BOX_KG);
}
